import { render, staticRenderFns } from "./LLWordTextContainer.vue?vue&type=template&id=07137dc2&scoped=true"
import script from "./LLWordTextContainer.vue?vue&type=script&lang=js"
export * from "./LLWordTextContainer.vue?vue&type=script&lang=js"
import style0 from "./LLWordTextContainer.vue?vue&type=style&index=0&id=07137dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07137dc2",
  null
  
)

export default component.exports